/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useEffect } from 'fierry/react';

import { getConfig, getInstance } from 'solis/auth/firebase';


export default () =>
{
  useEffect(() =>
  {
    if (getInstance().isPendingRedirect())
    {
      getInstance().start('#firebase-auth-container-redirect', getConfig());
    }
  }, []);

  return null;
};
